function normalizeSection(section) {
  return {
    section_name: section.key,
    key_values: section.fields,
  };
}

export function normalizeApplicationData(applicationData) {
  return {
    sections: applicationData.sections.map(normalizeSection),
  };
}
